import { useSelector } from 'react-redux';
import { getIsNewDeal } from 'store/dealManagement/selectors/getIsNewDeal';

export type PendoDataType = (label: string) => string;
interface UsePendoTrackingType {
  getPendoDataId: PendoDataType;
}

const formatDealPath = (pathName: string): string => {
  if (pathName.includes('/deal')) return '/deal';
  if (pathName.includes('/planner/programmatic')) return '/planner/programmatic';
  return '';
};

const usePendoTracking = (customUri?: string): UsePendoTrackingType => {
  const isNewDeal = useSelector(getIsNewDeal);
  const { pathname } = window.location;

  const getCurrentPageUrl = isNewDeal ? formatDealPath(pathname) : `${pathname.slice(0, pathname.lastIndexOf('/'))}/*`;

  const getPendoDataId = (label: string): string => `${customUri ?? getCurrentPageUrl} | ${label}`;

  return {
    getPendoDataId,
  };
};

export default usePendoTracking;
